import React from "react";
import { PageShell, EditableSection, EditableFeatureGrid } from "./PageShell";

const COMMITMENTS = [
  { badge: "Packaging", title: "Recyclable materials", body: "Glass bottles, aluminium caps, and card cartons designed for municipal recycling programmes." },
  { badge: "Small-batch", title: "Reduced overproduction", body: "We bottle in small batches based on real demand rather than warehousing large runs that risk expiring on shelves." },
  { badge: "Formula", title: "Vegan & cruelty-free", body: "Our formulas contain no animal derivatives and are never tested on animals at any stage." },
  { badge: "Refills", title: "Long-lived bottles", body: "Our 50ml bottles are designed to be kept. Once we roll out refill pouches, existing bottles will be refillable." },
  { badge: "Direct", title: "Fewer touchpoints", body: "Selling direct-to-you rather than through multiple wholesale layers reduces packaging, shipping, and transit emissions." },
];

const HONEST = [{
  heading: "What we’re not claiming",
  body: "We don’t call ourselves carbon-neutral, zero-waste, or eco-luxury — those are big claims that require independent audits. As we grow, we’ll publish measurable progress here rather than marketing slogans. If you have a specific sustainability question, please write to us.",
}];

const NEXT = [{
  heading: "What we’re working on",
  body: "Refillable formats, lighter bottle glass, and switching more of our packaging to post-consumer recycled material. Progress will be shared on this page as it happens.",
}];

export default function SustainabilityPage() {
  return (
    <PageShell
      slug="sustainability"
      testid="sustainability"
      eyebrow="Sustainability"
      title="A considered approach to luxury."
      intro="We take sustainability seriously enough to be honest about it. Here’s what we do today — and what we’re working on next."
    >
      <div className="mb-14">
        <h2 className="font-serif text-xl sm:text-2xl text-[#1A1918] mb-4">Where we start</h2>
        <EditableFeatureGrid slug="sustainability" sectionKey="today" fallback={COMMITMENTS} />
      </div>
      <EditableSection slug="sustainability" sectionKey="honest" fallback={HONEST} />
      <EditableSection slug="sustainability" sectionKey="future" fallback={NEXT} />
    </PageShell>
  );
}
